export default __webpack_public_path__ + "static/media/img2.12664553.jfif";